
import React, { Component}  from 'react';
import { NavLink } from 'react-router-dom';
import { DetailProvider, DetailContext } from 'core/DetailProvider';
import styled from 'styled-components';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { DateDisplay } from 'core/Display';
import ToggleChangesList from 'components/Changes/ToggleList';
import { DateWidget } from "form/new/DateWidget";
import OrderDetailPoint from './Parts/DetailPoint';
import OrderDetailInfo from './Parts/DetailInfo';
import OrderDetailExtraInfo from './Parts/DetailExtraInfo'
import OrderUploadDocuments from './UploadDocument/UploadDocuments';
import { DateTimeWidget } from 'form/new/DateTimeWidget';
import { Grid } from 'ui/Grid';
import {AsyncAutocompleteWidget} from "../../form/AutocompleteWidget";


const StyledDetail = styled.div`
  position: relative;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  grid-gap: 10px;
  align-items: center;
`;


export default class OrderDetail extends Component {

  handleUpdate = (context, name, value) => {
    context.setValue(name, value);
    const data = {};
    data[name] = value;
    context.patch(data)
  };

  render() {
    const { id, onClose, onUpdate, HeaderComponent, apiUrl = 'order', basePath = '/order', fromPath } = this.props;

    if (id === undefined) {
      return <></>;
    }

    return (
      <DetailProvider
        url={`${apiUrl}/${id}`}
        onUpdate={onUpdate}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            const editTo = fromPath
              ? { pathname: `${basePath}/${item.id}`, state: { from: fromPath } }
              : `${basePath}/${item.id}`;
            let editButton =
              <NavLink to={editTo}>
                <IconButton size="small">
                  <EditIcon />
                </IconButton>
              </NavLink>;

            return (
              <StyledDetail>
                <StyledHeader>
                  <IconButton size="small" onClick={() => onClose()}>
                    <CloseIcon/>
                  </IconButton>
                  <div className={'text-gray'}>№{item.id}</div>
                  <div><DateDisplay value={item.date_start} format={'DD.MM.YYYY в HH:mm'}/></div>
                  <div className={'text-right'}>
                    <NavLink to={`${basePath}/add/${item.id}`}>
                      <IconButton size="small" className={'mr-10'}>
                        <FileCopyOutlinedIcon />
                      </IconButton>
                    </NavLink>

                    {editButton}
                  </div>
                </StyledHeader>

                {HeaderComponent && HeaderComponent(detailContext)}

                <div className={'mt-25'}>
                  <AsyncAutocompleteWidget
                    optionLabel={'label'}
                    url={'catalog/order_status'}
                    label={'Статус перевозки'}
                    value={item.order_status}
                    size={'small'}
                    onChange={(value) => this.handleUpdate(detailContext, 'order_status', value)}
                  />
                </div>

                <div className={'mt-20'}>
                  <AsyncAutocompleteWidget
                    optionLabel={'label'}
                    url={'catalog/choice'}
                    filter={{
                      type: 'ORDER_TYPE'
                    }}
                    label={'Тип перевозки'}
                    value={item.order_type}
                    size={'small'}
                    onChange={(value) => this.handleUpdate(detailContext, 'order_type', value)}
                  />
                </div>

                <Grid columns={'1fr 1fr'} mobileColumns={'1fr'} className={'mb-20 mt-20'}>
                  <DateWidget
                    value={item.station_arrival_date}
                    label={'Дата прихода на станцию'}
                    size={'small'}
                    onChange={(value, stringValue) => this.handleUpdate(detailContext, 'station_arrival_date', stringValue)}
                  />
                  <div>
                    <DateWidget
                      value={item.station_arrival_notify_date}
                      label={'Дата уведомления'}
                      size={'small'}
                      onChange={(value, stringValue) => this.handleUpdate(detailContext, 'station_arrival_notify_date', stringValue)}
                    />
                  </div>
                </Grid>

                <Grid columns={'1fr 1fr'} mobileColumns={'1fr'} className={'mb-20 mt-25'}>
                  <div>
                    <DateTimeWidget
                      value={item.date_start}
                      label={'Дата начала'}
                      onChange={(value, stringValue) => this.handleUpdate(detailContext, 'date_start', value)}
                      size={'small'}
                      clearable={false}
                    />
                  </div>
                  <div>
                    <DateTimeWidget
                      value={item.date_end}
                      size={'small'}
                      label={'Дата завершения'}
                      onChange={(value, stringValue) => this.handleUpdate(detailContext, 'date_end', value)}
                      popperPlacement={'bottom-end'}
                    />
                  </div>
                </Grid>

                <div className={'mt-30'}>
                {(item.points || []).map((orderPoint, index) =>
                  <OrderDetailPoint
                    index={index}
                    key={orderPoint.id}
                    orderPoint={orderPoint}
                    context={detailContext}
                    handleUpdate={this.handleUpdate}
                  />
                )}
                </div>

                {item.description && (
                  <div className={'mt-15'}>
                    <div style={{ fontSize: '12px', color: '#828282', marginBottom: '5px'}}>Примечание к перевозке</div>
                    <div>{item.description}</div>
                  </div>
                )}

                <OrderDetailInfo detailContext={detailContext} order={item} />

                <OrderDetailExtraInfo order={item} />

                <div className={'mb-20'}>
                  <OrderUploadDocuments order={item} />
                </div>

                <ToggleChangesList item={item} />

              </StyledDetail>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
